
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateMeetingTypeDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    active: new FormControl<boolean | undefined>(undefined),
})
;
}
      